import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledResourceTypeCellSecondaryText = styled.span`
   ${basicSmallTextStyle}
`;

StyledResourceTypeCellSecondaryText.displayName = 'StyledResourceTypeCellSecondaryText';
